import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { defaultCatalogLinks, defaultContent } from './defaultState'

export const catalogLinks = handleActions({}, defaultCatalogLinks)
export const content = handleActions({}, defaultContent)

export default combineReducers({ catalogLinks, content })
